import lazy from 'react-lazy-with-preload';
import {
    SUNBURST_ADD_PHONE_PATHNAME,
    SUNBURST_ENTER_PASSWORD_PATHNAME,
    SUNBURST_OTP_PATHNAME
} from '../../shared/pathnames';

export const sunburstRoutes = [
    {
        path: SUNBURST_ADD_PHONE_PATHNAME,
        name: 'SunburstAddPhoneNumberPage',
        component: lazy(() => import('../../features/sunburst/addPhoneNumber/AddPhoneNumber')),
    },
    {
      path: SUNBURST_OTP_PATHNAME,  
      name: 'SunburstOTPPage',
      component: lazy(() => import('../../features/sunburst/otp/Otp')),
    },
    {
      path: SUNBURST_ENTER_PASSWORD_PATHNAME,  
      name: 'SunburstEnterPasswordPage',
      component: lazy(() => import('../../features/sunburst/enterPassword/EnterPassword')),
    }
]